import { render, staticRenderFns } from "./PurchaseErpIntegrationPopup.vue?vue&type=template&id=027bb058&"
import script from "./PurchaseErpIntegrationPopup.vue?vue&type=script&lang=js&"
export * from "./PurchaseErpIntegrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports